<template>
  <section class="luxury-showcase-section">
    <div class="luxury-bg">
      <div class="luxury-overlay"></div>
    </div>
    <div class="container">
      <div class="luxury-header">
        <div class="luxury-badge">
          <i :class="headerData.icon"></i>
          <span>{{ headerData.tag }}</span>
        </div>
        <h2>{{ headerData.title }}</h2>
        <p class="luxury-subtitle">{{ headerData.description }}</p>
      </div>
      
      <div class="luxury-services-grid">
        <div class="luxury-card" v-for="(service, index) in luxuryServices" :key="index">
          <div class="card-luxury-icon">
            <i :class="service.icon"></i>
          </div>
          <div class="card-luxury-content">
            <h3>{{ service.title }}</h3>
            <p>{{ service.description }}</p>
            <div class="luxury-features">
              <span v-for="(feature, featureIndex) in service.features" :key="featureIndex" class="luxury-tag">
                {{ feature }}
              </span>
            </div>
          </div>
          <div class="luxury-card-overlay">
            <div class="overlay-luxury-content">
              <h4>{{ service.title }}</h4>
              <p>{{ service.detailedDescription }}</p>
              <div class="luxury-price">
                <span class="price-label">Starting from</span>
                <span class="price-value">{{ service.price }}</span>
              </div>
              <button class="luxury-btn">{{ buttonText }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ServiceItsCardEliteComp",
  props: {
    headerData: {
      type: Object,
      required: true,
      default: () => ({
        icon: "fas fa-crown",
        tag: "ELITE SERVICES",
        title: "Champaran Elite Touch",
        description: "Exclusive premium automotive services for the most discerning customers"
      })
    },
    luxuryServices: {
      type: Array,
      required: true,
      default: () => []
    },
    buttonText: {
      type: String,
      required: false,
      default: "Book Service"
    }
  }
};
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Import Flaticon */
@import '@/assets/scss/Flaticon.scss';

/* Luxury Services Showcase Section */
.luxury-showcase-section {
  padding: 100px 0;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  color: white;
  position: relative;
  overflow: hidden;
}

.luxury-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('~@/assets/resource/portfolio-03.jpg') no-repeat center center;
  background-size: cover;
  opacity: 0.1;
  z-index: 1;
}

.luxury-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(26, 26, 26, 0.8), rgba(45, 45, 45, 0.8));
  z-index: 2;
}

.container {
  position: relative;
  z-index: 3;
}

.luxury-header {
  text-align: center;
  margin-bottom: 60px;
}

.luxury-badge {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #d4af37, #b8860b);
  color: #1a1a1a;
  padding: 10px 25px;
  border-radius: 30px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin-bottom: 25px;
  box-shadow: 0 5px 15px rgba(212, 175, 55, 0.3);
}

.luxury-header h2 {
  font-size: 52px;
  font-weight: 800;
  color: white;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.luxury-subtitle {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.8);
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
}

.luxury-services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));
  gap: 40px;
  margin-top: 60px;
}

.luxury-card {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 25px;
  padding: 45px 35px;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(212, 175, 55, 0.2);
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.luxury-card:hover {
  transform: translateY(-20px) scale(1.03);
  box-shadow: 0 30px 60px rgba(212, 175, 55, 0.3);
  border-color: #d4af37;
  background: rgba(255, 255, 255, 0.08);
}

.card-luxury-icon {
  width: 90px;
  height: 90px;
  background: linear-gradient(135deg, #d4af37, #b8860b);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  transition: all 0.4s ease;
  box-shadow: 0 10px 25px rgba(212, 175, 55, 0.4);
}

.luxury-card:hover .card-luxury-icon {
  transform: scale(1.15) rotate(10deg);
  box-shadow: 0 15px 35px rgba(212, 175, 55, 0.6);
}

.card-luxury-icon i {
  font-size: 36px;
  color: #1a1a1a;
}

.card-luxury-content {
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.card-luxury-content h3 {
  font-size: 26px;
  font-weight: 700;
  color: white;
  margin-bottom: 18px;
  font-family: 'Archivo', sans-serif;
}

.card-luxury-content p {
  font-size: 17px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 25px;
  line-height: 1.6;
}

.luxury-features {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: auto;
}

.luxury-tag {
  background: linear-gradient(135deg, #d4af37, #b8860b);
  color: #1a1a1a;
  padding: 6px 15px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.luxury-card-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(212, 175, 55, 0.95), rgba(184, 134, 11, 0.95));
  backdrop-filter: blur(20px);
  color: #1a1a1a;
  padding: 45px 35px;
  border-radius: 25px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateY(30px);
}

.luxury-card:hover .luxury-card-overlay {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.luxury-card:hover .card-luxury-content {
  opacity: 0;
  transform: translateY(-30px);
}

.overlay-luxury-content {
  text-align: center;
  transform: translateY(20px);
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.luxury-card:hover .overlay-luxury-content {
  transform: translateY(0);
}

.overlay-luxury-content h4 {
  font-size: 26px;
  font-weight: 700;
  margin-bottom: 18px;
  font-family: 'Archivo', sans-serif;
  color: #1a1a1a;
}

.overlay-luxury-content p {
  font-size: 17px;
  margin-bottom: 25px;
  line-height: 1.6;
  color: rgba(26, 26, 26, 0.8);
}

.luxury-price {
  margin-bottom: 25px;
}

.price-label {
  display: block;
  font-size: 14px;
  color: rgba(26, 26, 26, 0.7);
  margin-bottom: 5px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.price-value {
  font-size: 28px;
  font-weight: 800;
  color: #1a1a1a;
  font-family: 'Archivo', sans-serif;
}

.luxury-btn {
  background: #1a1a1a;
  color: #d4af37;
  border: none;
  padding: 15px 35px;
  border-radius: 30px;
  font-weight: 700;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.4s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 5px 20px rgba(26, 26, 26, 0.3);
  position: relative;
  overflow: hidden;
}

.luxury-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(212, 175, 55, 0.3), transparent);
  transition: left 0.6s;
}

.luxury-btn:hover::before {
  left: 100%;
}

.luxury-btn:hover {
  background: #2d2d2d;
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(26, 26, 26, 0.4);
}

/* Responsive Design */
@media (max-width: 768px) {
  .luxury-services-grid {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .luxury-card {
    padding: 35px 25px;
  }
  
  .luxury-header h2 {
    font-size: 42px;
  }
  
  .luxury-subtitle {
    font-size: 18px;
  }
}
</style>
